import {
    findAnalytics,
    logToAnalyticsBetSuccess,
    logToAnalyticsBetError,
    logToAnalyticsBuildError,
    logToAnalyticsBookmakerLoginSuccess,
    logToAnalyticsBookmakerLogin,
    logToAnalyticsBookmakerLoginFailure,
} from './analyticsTracking';
import { actions as betActions } from '../common/bet';
import { actions as bookmakersInfoActions } from '../common/bookmakersInfo';
import { actions as bookmakersListActions } from '../common/bookmakersList';
import { create as createLogger } from '../common/utils/logger';

const logger = createLogger('analyticsMiddleware');

export default function analyticsMiddleware(store) {
    const analytics = findAnalytics();
    if (!analytics) {
        return next => action => next(action);
    }
    return next =>
        (action) => {
            try {
                switch (action.type) {
                    case betActions.actionTypes.PLACE_BET_SUCCESS:
                        logToAnalyticsBetSuccess(action, store, analytics);
                        break;
                    case bookmakersInfoActions.actionTypes.SET_SUSPENDED_BET:
                    case bookmakersInfoActions.actionTypes.SET_PRICE_CHANGED:
                    case bookmakersInfoActions.actionTypes.SET_GENERIC_ERROR:
                    case bookmakersInfoActions.actionTypes.SET_ERROR:
                        logToAnalyticsBetError(action, store, analytics);
                        break;
                    case bookmakersInfoActions.actionTypes.SET_SUSPENDED_BET_ON_BUILD:
                    case bookmakersInfoActions.actionTypes.SET_PRICE_CHANGED_ON_BUILD:
                    case bookmakersInfoActions.actionTypes.SET_GENERIC_ERROR_ON_BUILD:
                    case bookmakersInfoActions.actionTypes.SET_ERROR_ON_BUILD:
                    case bookmakersInfoActions.actionTypes.SET_MULTIPLES_ERROR:
                        logToAnalyticsBuildError(action, store, analytics);
                        break;
                    case bookmakersListActions.actionTypes.SET_LOGIN:
                        logToAnalyticsBookmakerLogin(action, store, analytics);
                        break;
                    case bookmakersListActions.actionTypes.SET_LOGIN_SUCCESS:
                        logToAnalyticsBookmakerLoginSuccess(action, store, analytics);
                        break;
                    case bookmakersListActions.actionTypes.SET_LOGIN_FAILURE:
                        logToAnalyticsBookmakerLoginFailure(action, store, analytics);
                        break;
                    // no default
                }
            } catch (e) {
                logger.error(e);
            }
            return next(action);
        };
}



// WEBPACK FOOTER //
// /src/js/App/analytics.middleware.js